import { action, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import UiMeet3dLinkRepository from "~/repository/UiMeet3d/UiMeet3dLinkRepository";
import UiMeet3dLink from "~/models/UiMeet3d/UiMeet3dLink";

class UiMeet3dLinkStore extends NestStore {
  /**
   * @property {Array}
   */
  @observable uiMeet3dLinks = [];

  /**
   * @property {UiMeet3dLink|null}
   */
  @observable uiMeet3dLink = null;

  /**
   * @property {number|null}
   */
  uiMeet3dLinkId = null;

  uiMeet3dLinkRepository = null;

  constructor() {
    super();

    this.uiMeet3dLinkRepository = new UiMeet3dLinkRepository();

    this.setDefaultSearchParams();
  }

  /**
   * Set default search params.
   */
  @action
  setDefaultSearchParams() {
    this.searchParams.tourId = "";
  }

  @action
  loadIndex() {
    this.isLoading = true;

    return Promise.all([this.getAll()]).finally(() => {
      this.isLoading = false;
    });
  }

  /**
   * Get all.
   */
  @action
  getAll() {
    const params = {
      offset: this.offset,
      limit: this.pagination.itemsPerPage,
    };

    if (this.searchParams.tourId !== "") {
      params.tourId = this.searchParams.tourId;
    }

    return this.uiMeet3dLinkRepository.fetch(this.locale, params).then(response => {
      this.processEntities(response.data.uiMeet3dLinks);
      this.processPagination(response.data.pagination);
    });
  }

  @action
  processEntities(uiMeet3dLinks = []) {
    this.uiMeet3dLinks = [];

    uiMeet3dLinks.forEach(uiMeet3dLinkArray => {
      const uiMeet3dLink = new UiMeet3dLink(uiMeet3dLinkArray);

      this.uiMeet3dLinks.push(uiMeet3dLink);
    });
  }
}

export default UiMeet3dLinkStore;
